import React, { useState, useEffect } from "react";
import classnames from "classnames";
import BackgroundVideo from "../components/Background-Video";
import BackButton from "../partials/Back-Button";
import Videos from "../video/101160_SCS_Interactive_Sc4_4K_10s_V2.mp4";

const ConstructionProductivity = () => {
  const [activeDot, setActiveDot] = useState("");
  const [dotOneX, setDotOneX] = useState();
  const [dotOneY, setDotOneY] = useState();
  const [blobOneX, setBlobOneX] = useState();
  const [blobOneY, setBlobOneY] = useState();
  const [dotTwoX, setDotTwoX] = useState();
  const [dotTwoY, setDotTwoY] = useState();
  const [blobTwoX, setBlobTwoX] = useState();
  const [blobTwoY, setBlobTwoY] = useState();
  const [dotThreeX, setDotThreeX] = useState();
  const [dotThreeY, setDotThreeY] = useState();
  const [blobThreeX, setBlobThreeX] = useState();
  const [blobThreeY, setBlobThreeY] = useState();

  const getPosition = () => {
    const dotOne = document.getElementById("dotOne").getBoundingClientRect();
    const dotOneTop = dotOne.top;
    const dotOneLeft = dotOne.left;

    setDotOneX(dotOneLeft + 21.5);
    setDotOneY(dotOneTop + 21.5);

    const blobOne = document.getElementById("blobOne").getBoundingClientRect();
    const blobOneTop = blobOne.top;
    const blobOneLeft = blobOne.left;

    setBlobOneX(blobOneLeft);
    setBlobOneY(blobOneTop);

    const dotTwo = document.getElementById("dotTwo").getBoundingClientRect();
    const dotTwoTop = dotTwo.top;
    const dotTwoLeft = dotTwo.left;

    setDotTwoX(dotTwoLeft + 21.5);
    setDotTwoY(dotTwoTop + 21.5);

    const blobTwo = document.getElementById("blobTwo").getBoundingClientRect();
    const blobTwoTop = blobTwo.top;
    const blobTwoLeft = blobTwo.left;

    setBlobTwoX(blobTwoLeft);
    setBlobTwoY(blobTwoTop);

    const dotThree = document
        .getElementById("dotThree")
        .getBoundingClientRect();
    const dotThreeTop = dotThree.top;
    const dotThreeLeft = dotThree.left;

    setDotThreeX(dotThreeLeft + 21.5);
    setDotThreeY(dotThreeTop + 21.5);

    const blobThree = document
        .getElementById("blobThree")
        .getBoundingClientRect();
    const blobThreeTop = blobThree.top;
    const blobThreeLeft = blobThree.left;

    setBlobThreeX(blobThreeLeft);
    setBlobThreeY(blobThreeTop);

  };

  useEffect(() => {
    getPosition();
  }, []);

  return (
      <div className="w-screen h-[calc(100vh-172px)] relative top-[172px] left-0">
        <BackButton backurl="/connected-laptop" />
        <BackgroundVideo
            fullscreen
            video={Videos}
        />
        <div className="w-screen h-[calc(100vh-172px)] relative ">
          <div className="awkward-size bg-opacity-50 backdrop-blur-md bg-white w-[420px] -top-[30px] xl:w-[500px] 2xl:w-[700px]  py-7 px-9 2xl:py-14 2xl:px-[59px]  rounded-3xl relative left-10 top-5 mr-auto">
            <h1 className="uppercase text-dell-blue font-proxima-nova font-semibold text-lg 2xl:text-[25px] 2xl:leading-[30px] pb-3 xl:text-[20px]">
              CONSTRUCTION SITE PRODUCTIVITY
            </h1>
            <p className="font-proxima-nova text-[#444444] text-xl 2xl:text-[30px] 2xl:leading-[37px] font-thin xl:text-[24px]">
              Monetize your 5G investment and add users to your network by delivering secure productivity for your construction customers working remotely with Dell’s connected laptop.
            </p>
          </div>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 1 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotOneX}
                y1={dotOneY}
                x2={blobOneX}
                y2={blobOneY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 2 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotTwoX}
                y1={dotTwoY}
                x2={blobTwoX}
                y2={blobTwoY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 3 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotThreeX}
                y1={dotThreeY}
                x2={blobThreeX}
                y2={blobThreeY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <div className="edge-dots absolute w-screen h-[calc(100vh-172px)] top-0 grid grid-cols-5 grid-rows-3">
            <div></div>
            <div></div>
            <div className="relative flex justify-center items-end">
              <div
                  id="dotOne"
                  className="dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] top-[80px] left-14 bg-[#444444] border-2 cursor-pointer"
                  onMouseEnter={() => setActiveDot(1)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(1)}
                  onKeyDown={() => setActiveDot("")}
                  tabIndex={0}
              ></div>
              <div
                  id="blobOne"
                  className={classnames(
                      "absolute top-44 right-24 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#444444] text-white min-w-[400px] h-[400px] transition-all duration-300 ",
                      activeDot === 1
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Engineer:
                </p>
                <p className="font-proxima-nova text-[20px] leading-[24px] font-thin">
                  A connected laptop enables the engineer to utilize the high bandwidth available from a cellular network to access CAD programs and design plans.
                </p>
              </div>
            </div>
            <div className="relative flex justify-center items-end">
              <div
                  id="dotTwo"
                  className="dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] bg-[#444444] border-2 left-[40px] top-[100px] cursor-pointer"
                  onMouseEnter={() => setActiveDot(2)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(2)}
                  onKeyDown={() => setActiveDot("")}
                  tabIndex={0}
              ></div>
              <div
                  id="blobTwo"
                  className={classnames(
                      "absolute top-32 right-36 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#444444] text-white min-w-[443px] h-[443px] transition-all duration-300",
                      activeDot === 2
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Project Manager:
                </p>
                <p className="font-proxima-nova text-[20px] leading-[24px] font-thin">
                  By using a connected laptop, the project manager is able to immediately upload changes to their project plan and share real-time insights with stakeholders.
                  <br />
                  <br/>
                  They are also able to securely contact suppliers to place orders, obtain updates and track delivery.
                </p>
              </div>
            </div>
            <div></div>
            <div></div>


            <div></div>
            <div></div>

            <div className="relative flex justify-end items-start">
              <div
                  id="dotThree"
                  className="dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] bg-[#444444] border-2 -top-[40px] cursor-pointer"
                  onMouseEnter={() => setActiveDot(3)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(3)}
                  onKeyDown={() => setActiveDot("")}
                  tabIndex={0}
              ></div>

              <div
                  id="blobThree"
                  className={classnames(
                      "absolute bottom-[0px] right-10 -top-10 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#444444] text-white min-w-[443px] h-[443px] transition-all duration-300",
                      activeDot === 3
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className="text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Safety Officer:
                </p>
                <p className="font-proxima-nova text-[20px] leading-[24px] font-thin">
                  The safety officer is able to access SaaS applications and documents quickly using a connected laptop.
                  <br/>
                  <br/>
                  They are also able to quickly upload audit findings, including key images, citations and file certificates.
                </p>
              </div>
            </div>



          </div>
        </div>
      </div>
  );
};

export default ConstructionProductivity;
